import axios from "@/utils/axios";

export default async function (id) {
  const response = await axios.get(`/lomadee/coupons/stores/${id}`);

  return response.data;
}
